import React from "react";

class Category extends React.Component {
  constructor(props) {
    super(props);
  }

  _handleClick = (e) => {
    e.preventDefault();
    this.props.clickCategory(this.props.item);
  };

  render() {
    return (
      <a
        href={"#"}
        className={
          "gallery-explorer-category" +
          (this.props.isActiveCategory ? " selected" : "")
        }
        onClick={this._handleClick}
      >
        <div className="image">
          <div className="image-inner">
            <img src={this.props.item.image} alt={this.props.item.category} />
          </div>
        </div>
        <div className="text">{this.props.item.category}</div>
      </a>
    );
  }
}

export default Category;
